export default {
	methods: {
		resetTimeField() {
			this.model.time = this.timetable && this.timetable[0] ? this.timetable[0].id : null;
		}
	}
};
